import { fontSizeVars, spacingVars } from '@tundr/ds-foundations';
import { style } from '@vanilla-extract/css';

export const paginatorWrapperClass = style({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  fontSize: fontSizeVars.body.body1,
  flexBasis: 'auto',
  gap: spacingVars.lg,
});

export const paginatorLoadingClass = style({
  opacity: 0.5,
});
